"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function MessageIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "7.351", y: "7.715", width: "9.297", height: "1.699" }),
        react_1.default.createElement("rect", { x: "7.351", y: "11.343", width: "9.297", height: "1.699" }),
        react_1.default.createElement("path", { d: "M12,2C6.321,2,1.7,5.816,1.7,10.5a7.9,7.9,0,0,0,3.623,6.467L4.3,20.934a.851.851,0,0,0,1.209.97l5.742-2.925c.247.016.5.024.749.024,5.68,0,10.3-3.813,10.3-8.5S17.68,2,12,2Zm0,15.3c-.29,0-.574-.013-.856-.036a.931.931,0,0,0-.454.089L6.418,19.533l.7-2.726a.852.852,0,0,0-.379-.938A6.388,6.388,0,0,1,3.4,10.5c0-3.75,3.858-6.8,8.6-6.8s8.6,3.051,8.6,6.8S16.742,17.3,12,17.3Z" })));
}
exports.default = MessageIcon;
